import React from 'react';
export const SectionHeader = ({ icon, title, subtitle, open, onToggle, color, dimmed, onDimClick }) => {
  const c = color || 'var(--accent)';
  return (
    <div onClick={dimmed ? onDimClick : onToggle}
      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        cursor: 'pointer', padding: '9px 14px', margin: '10px 0 4px',
        background: 'var(--bg-card)', border: '1px solid var(--border)',
        borderLeft: `3px solid ${c}`, borderRadius: open ? '8px 8px 0 0' : 8,
        opacity: dimmed ? 0.35 : 1, transition: 'opacity 0.25s ease' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0, flex: 1 }}>
        <span style={{ fontSize: 19, flexShrink: 0 }}>{icon}</span>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 17, fontWeight: 700, color: c }}>{title}</div>
          {!open && subtitle && (
            <div style={{ fontSize: 13, color: 'var(--text-muted)', overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginTop: 1 }}>{subtitle}</div>
          )}
        </div>
      </div>
      <span style={{ fontSize: 14, fontWeight: 700, padding: '3px 8px', borderRadius: 10,
        flexShrink: 0, marginLeft: 8, transition: 'all 0.2s',
        color: open ? 'var(--text-muted)' : c,
        background: 'transparent' }}>
        {open ? 'Less ▴' : 'Show ▾'}
      </span>
    </div>
  );
};
